import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing, inlineEdit, editable, isToggle } from 'src/types/columnFlags';
const controlledActions = {
    create: [484],
    fetch: [485],
    update: [486],
    delete: [487],
    downloadList: [485],
    uploadList: [484]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'name', inlineEdit },
        { name: 'parent_id', editable, references: 'controlled_actions.controlled_action_groups' },
        { name: 'disabled', editable, isToggle }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'controlled_actions.controlled_action_groups',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Controlled action groups'
});
export default localEntity;
